import {
  MarkAllNotificationsAsRead_Input,
  useNotificationWidgetQuery,
  useSaveNotificationWidgetMutation
} from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  title: string;
  content: string;
  isRead: boolean;
}

export function useQuery() {


  const tuple = useNotificationWidgetQuery({
    variables: {
      options: {
        filter: {
          isRead: false
        }
      }
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.notifications.map((node) => ({
        id: node.id,
        title: node.title,
        content: node.content,
        isRead: node.isRead
      })) ?? [];

      return {
        ...tuple,
        data: data
      };
    },
    [tuple]
  );
}


export function useSaveNotification() {
  const [
    fnMutate,
    tuple
  ] = useSaveNotificationWidgetMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: MarkAllNotificationsAsRead_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}

